document.addEventListener("DOMContentLoaded", function () {

  function addBusinessDays(startDate, businessDays) {
    const date = new Date(startDate);
    let addedDays = 0;

    while (addedDays < businessDays) {
      date.setDate(date.getDate() + 1);

      const day = date.getDay();
      if (day !== 0 && day !== 6) {
        addedDays++;
      }
    }

    return date;
  }

  function enforceRule() {
    const days = document.querySelectorAll(".picker__day");
    if (!days.length) return;

    const today = new Date();
    const orderDay = today.getDay(); // 0 = Sun, 5 = Fri, 6 = Sat

    let minDate;

    if (orderDay === 5 || orderDay === 6 || orderDay === 0) {
      // Friday, Saturday, Sunday → next Wednesday
      minDate = new Date(today);

      let daysUntilWednesday = (3 - orderDay + 7) % 7;
      if (daysUntilWednesday === 0) daysUntilWednesday = 7;

      minDate.setDate(today.getDate() + daysUntilWednesday);
    } else {
      // Monday–Thursday → 2 full business days
      minDate = addBusinessDays(today, 2);
    }

    minDate.setHours(0, 0, 0, 0);

    days.forEach(day => {
      const label = day.getAttribute("aria-label");
      if (!label) return;

      const date = new Date(label + " 00:00:00");

      if (date < minDate) {
        day.classList.add("picker__day--disabled");
        day.setAttribute("aria-disabled", "true");
      }
    });
  }

  enforceRule();

  const observer = new MutationObserver(function () {
    enforceRule();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});